import { render, staticRenderFns } from "./DishTagsSheet.vue?vue&type=template&id=1dbb416c"
import script from "./DishTagsSheet.vue?vue&type=script&lang=js"
export * from "./DishTagsSheet.vue?vue&type=script&lang=js"
import style0 from "./DishTagsSheet.vue?vue&type=style&index=0&id=1dbb416c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports